<template>
  <transition mode="out-in">
    <VStudio20PresetsClosed
      @open="toggleOpen()"
      v-if="!open"
      key="closed-panel"
    >
    </VStudio20PresetsClosed>
    <VStudio20PresetsOpened
      v-else
      key="open-panel"
      @close="toggleOpen()"
      :component="component"
      :handler="handler"
    >
    </VStudio20PresetsOpened>
  </transition>
</template>
<script>

import VStudio20PresetsClosed from "./VStudio20PresetsClosed.vue";
import VStudio20PresetsOpened from "./VStudio20PresetsOpened.vue";

export default {
  translate25Context: 'vstudio20_presets',
  data: function () {
    return {
      open: sessionStorage.getItem("VStudio20PresetsOpen") != 'closed',
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;

      if (this.open) {
        sessionStorage.removeItem("VStudio20PresetsOpen");
      } else {
        sessionStorage.setItem("VStudio20PresetsOpen", "closed");
      }
    }
  },
  components: {
    VStudio20PresetsOpened,
    VStudio20PresetsClosed,
  },
  props: ["component", "handler"],
};
</script>